import { useMutation } from '@tanstack/react-query';
import { getCityAttributes } from '@/api/cityAttributes';
import { CityAttributes, GetDeleteCityAttributesData, PostParam } from "@/types/index";

export function useGetCityAttributes(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<CityAttributes, Error, GetDeleteCityAttributesData>({
    mutationFn: getCityAttributes,
    onSuccess,
    onError
  });
}
